module.exports = __webpack_public_path__ + "static/img/about-ad4.d972226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg/about-ad4.jpg
// module id = FiNv
// module chunks = 3